import { render, staticRenderFns } from "./PostText.vue?vue&type=template&id=edf921b6"
import script from "./PostText.vue?vue&type=script&lang=js"
export * from "./PostText.vue?vue&type=script&lang=js"
import style0 from "./PostText.vue?vue&type=style&index=0&id=edf921b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports